import logo from './logo.svg';
import './App.css';
import { useCallback, useEffect, useState, useRef } from 'react';
import { Route, Routes, BrowserRouter, useLocation } from 'react-router-dom';
import Lobby from './components/Lobby.js';
import FoldVideo from './components/FoldVideo.js';
import PageNotFound from './components/PageNotFound.js';
import OldSite from './components/OldSite.js';
import { HelmetProvider, Helmet } from 'react-helmet-async';






function App() {

	const [subdomain, setSubdomain] = useState(null);


	useEffect(() => {
		const host = window.location.host; 									// get full domain of app
		const subdomainArray = host.split(".")								// split domain into top, second and sub level domains; e.g. ['subdomain', 'domain', 'com']
			.slice(0, host.includes("localhost") ? -1 : -2); 				//remove 'localhost:3000', or 'domain, 'com' from the array to leave behind subdomain
		if (subdomainArray.length > 0) setSubdomain(subdomainArray[0]); 	// if resulting array has 0 elements, there's no subdomain, otherwise it'll be the first element of the array
	}, []);



	return (
		<BrowserRouter>
			<HelmetProvider>

				<Helmet>
					{subdomain ?
						(subdomain === "old" ?
							(<>
								<title>Jonathan Liew | Design (Archived Site)</title>
							</>) :
							(<>
							</>))
						:
						(<></>)
					}
				</Helmet>


				<Routes>
					{subdomain ?
						(<>
							{(subdomain === "" || subdomain === "192") ?
								(<>
									<Route path="/" element={<Lobby jazz={false} />} />
									<Route path="*" element={<PageNotFound />} />
								</>) :
								subdomain === "jazz" ?
									(<>
										<Route path="/" element={<Lobby jazz={true} />} />
										<Route path="*" element={<PageNotFound />} />
									</>) :
									subdomain === "old" ?
										(<>
											<Route path="/" element={<OldSite />} />
											<Route path="*" element={<OldSite />} />
										</>) :
										(<>
											<Route path="*" element={<PageNotFound />} />
										</>)}
						</>) :
						(<>
							<Route path="/" element={<Lobby jazz={false} />} />
							<Route path="*" element={<PageNotFound />} />
						</>)}
				</Routes>
			</HelmetProvider>
		</BrowserRouter>

	);
}

export default App;
